/**
 * useNextAction — Round 218A P0 Final (2026-02-07).
 *
 * The ONE frontend hook every completion screen + Money Bot builder
 * calls to decide "where does the customer go next?". PayGBot
 * decides sequencing. The customer only Edits / Approves / Generates.
 *
 * Backed by GET /api/foundation/next-action (active-business scoped,
 * zero-credit).
 *
 * Returns:
 *   {
 *     loading, error,
 *     nextStepId, nextRoute, nextCtaLabel, reason,
 *     foundationComplete,
 *     activeBusinessId, activeBusinessName,
 *     refresh: () => Promise<void>,
 *   }
 */
import { useCallback, useEffect, useState } from 'react';
import api from '@/utils/api';

const EMPTY = {
  loading: true,
  error: null,
  nextStepId: null,
  nextRoute: null,
  nextCtaLabel: null,
  reason: null,
  foundationComplete: false,
  activeBusinessId: null,
  activeBusinessName: null,
};

export default function useNextAction(active = true) {
  const [snap, setSnap] = useState(EMPTY);

  const load = useCallback(async () => {
    try {
      const res = await api.get('/foundation/next-action');
      const a = res.data?.action || {};
      setSnap({
        loading: false,
        error: null,
        nextStepId:         a.next_step_id || null,
        nextRoute:          a.next_route || null,
        nextCtaLabel:       a.next_cta_label || null,
        reason:             a.reason || null,
        foundationComplete: !!a.foundation_complete,
        activeBusinessId:   a.active_business_id || null,
        activeBusinessName: a.active_business_name || null,
      });
    } catch (err) {
      setSnap({ ...EMPTY, loading: false, error: err });
    }
  }, []);

  useEffect(() => {
    if (!active) return;
    load();
  }, [active, load]);

  return { ...snap, refresh: load };
}
